module.exports = __webpack_public_path__ + "img/finish-ar.b10bbd6d.png";